import React from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import { userActions, geoActions } from '../../redux/actions'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import RegisterForm from '../../components/Form/RegisterForm/RegisterForm'
import { currentUser } from '../../redux/reducers/user.reducers'
import Error from '../../components/Error/Error'

class Register extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      country: '',
      language: '',
    }
  }

  componentDidMount() {
    const { getCountry } = this.props
    getCountry()
  }

  componentWillUnmount() {
    const { clearState } = this.props
    clearState()
  }

  static getDerivedStateFromProps(props, state) {
    const { countryCode, languageCode } = props

    if (countryCode !== state.country && languageCode !== state.language) {
      return { country: countryCode, language: languageCode }
    }
    return null
  }

  _handleRegister = values => {
    const { country, language } = this.state
    const { register } = this.props
    const mergedValues = {
      ...values,
      country,
      language,
    }
    return register(mergedValues)
  }

  _handleChange = e => {
    const { value } = e.target
    this.setState({ language: value })
  }

  render() {
    const {
      countryCode,
      countryLoading,
      registerLoading,
      securityBlockedError,
      securityBlockedMessage,
      intl,
      isModal = false,
    } = this.props
    const { language } = this.state

    if (securityBlockedError) {
      return (
        <Error message={securityBlockedMessage} dontShowSupport header="global.label.attention" />
      )
    }
    const label = intl.formatMessage({ id: 'global.pageTitles.register' })
    return (
      <div className="register-page mb-5" role="main" aria-label={label} tabIndex={-1}>
        <Helmet>
          <title>{label}</title>
        </Helmet>
        <div className="container mt-5 mb-5">
          <h1
            className="page-title"
            aria-level="1"
            aria-label={intl.formatMessage({ id: 'page.registrationPage.title.heroTitle' })}
          >
            <FormattedMessage id="page.registrationPage.title.heroTitle" />
          </h1>
          <h4
            aria-level="2"
            aria-label={intl.formatMessage({ id: 'page.registrationPage.title.description' })}
          >
            <FormattedMessage id="page.registrationPage.title.description" />
          </h4>
          <p aria-label={intl.formatMessage({ id: 'page.registrationPage.title.note' })}>
            <FormattedMessage id="page.registrationPage.title.note" />
          </p>
          <div className={`row ${isModal ? '' : 'justify-content-center'}`}>
            <div className={isModal ? 'col' : 'col-md-8 col-xl-6'}>
              <RegisterForm
                languageCode={language}
                countryCode={countryCode}
                countryLoading={countryLoading}
                registerLoading={registerLoading}
                handleChange={this._handleChange}
                onSubmit={this._handleRegister}
                isModal={this.props.isModal}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: currentUser(state),
  countryCode: state.geoReducers.countryCode,
  languageCode: state.geoReducers.languageCode,
  countryLoading: state.geoReducers.loading,
  registerLoading: state.userReducers.registerLoading,
  securityBlockedError: state.userReducers.securityBlockedError,
  securityBlockedMessage: state.userReducers.securityBlockedMessage,
})

const mapDispatchToProps = dispatch => ({
  getCountry: () => dispatch(geoActions.getCountry()),
  register: (...args) => dispatch(userActions.register(...args)),
  clearState: (...args) => dispatch(userActions.clearState(...args)),
})

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Register))
